import type { MultiRefResourceItem } from '../types'

/**
 * Per-kind `addedAt` offsets used to preserve the deterministic
 * image → video → audio order when reconstructing the items array from
 * separate id lists. The gap (1000) is larger than any realistic per-kind
 * ref count (caps are single-digit), so no overlap is possible.
 */
const IMAGE_ADDED_AT_OFFSET = 0
const VIDEO_ADDED_AT_OFFSET = 1000
const AUDIO_ADDED_AT_OFFSET = 2000

/**
 * Reconstruct an items array from the per-kind id arrays. Used both for
 * back-compat (legacy state without `items`) and for prefill from saved tasks.
 * Offsets are stable (index-based, no `Date.now()`) so subsequent calls with
 * the same input produce identical output.
 */
export function buildItemsFromKindArrays(
  imageIds: readonly string[],
  videoIds: readonly string[],
  audioIds: readonly string[],
): MultiRefResourceItem[] {
  const items: MultiRefResourceItem[] = []
  imageIds.forEach((mediaId, i) =>
    items.push({ mediaId, kind: 'image', addedAt: IMAGE_ADDED_AT_OFFSET + i }),
  )
  videoIds.forEach((mediaId, i) =>
    items.push({ mediaId, kind: 'video', addedAt: VIDEO_ADDED_AT_OFFSET + i }),
  )
  audioIds.forEach((mediaId, i) =>
    items.push({ mediaId, kind: 'audio', addedAt: AUDIO_ADDED_AT_OFFSET + i }),
  )
  return items
}
